import { render, staticRenderFns } from "./addCardService.vue?vue&type=template&id=3a57990e&scoped=true&"
import script from "./addCardService.vue?vue&type=script&lang=js&"
export * from "./addCardService.vue?vue&type=script&lang=js&"
import style0 from "./addCardService.vue?vue&type=style&index=0&id=3a57990e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a57990e",
  null
  
)

export default component.exports